import { NavLink } from "react-router-dom";
import "./ProcurementSidebar.css";

export default function ProcurementSidebar({ isOpen, onClose }) {
  const handleLinkClick = () => {
    if (window.innerWidth <= 840) {
      onClose();
    }
  };

  return (
    <aside className={`procurement-sidebar ${isOpen ? "open" : ""}`}>
      <div className="sidebar-header">
        <h2 className="sidebar-title">Procurement</h2>
        <button className="sidebar-close-btn" onClick={onClose}>
          ✕
        </button>
      </div>

      <nav className="sidebar-nav">
        <NavLink
          to="/procurement"
          end
          className={({ isActive }) =>
            `procurement-menu-item ${isActive ? "active" : ""}`
          }
          onClick={handleLinkClick}
        >
          Dashboard
        </NavLink>

        <NavLink
          to="/procurement/purchase-orders"
          className={({ isActive }) =>
            `procurement-menu-item ${isActive ? "active" : ""}`
          }
          onClick={handleLinkClick}
        >
          Purchase Orders
        </NavLink>

        <NavLink
          to="/procurement/invoices"
          className={({ isActive }) =>
            `procurement-menu-item ${isActive ? "active" : ""}`
          }
          onClick={handleLinkClick}
        >
          Invoices
        </NavLink>

        <NavLink
          to="/procurement/payments"
          className={({ isActive }) =>
            `procurement-menu-item ${isActive ? "active" : ""}`
          }
          onClick={handleLinkClick}
        >
          Payments
        </NavLink>
      </nav>
    </aside>
  );
}
